<template>
  <div class="wrapper flex justify-center align-items-center">
    <div class="progress-container">
      <p class="q-mb-md">
        <img
          class="airteam-logo"
          src="@/assets/model/airteam_transparent.svg"
        />
        AIRTEAM
      </p>
      <p class="progress-hint q-mt-md">Loading 3D model</p>
      <div v-if="error">
        <p style="color: red; font-size: 1rem">
          {{ getErrorMessage() }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api/API";
import { authService } from "@/services/authService";
import { isProduction } from "@/utils/env";

export default {
  name: "Bobbie",
  data() {
    return {
      error: null,
      attempts: 0,
    };
  },
  async created() {
    const tokenString = decodeURIComponent(
      window.location.hash.replace(/^#/, "")
    ).split("?")[0];
    const token = JSON.parse(tokenString);
    if (!token || !token.bobbieToken || !token.currentProject) {
      console.error(`no or wrong token provided: ${token}`);
      this.error = "no_token";
      return;
    }

    // Set Bobbie context in store only if we have a valid bobbieToken
    if (token.bobbieToken) {
      this.$store.commit("setIsBobbieContext", true);
      document.body.classList.add("bobbie-theme");
      console.log("Bobbie context set in store");
    }

    const airteamTokens = await this.validateToken(token.bobbieToken);
    if (airteamTokens) {
      await authService.manualUserLogIn(airteamTokens);

      this.$router.push(`/${token.currentProject}`);
    } else {
      this.error = this.$t("bobbie.error");
    }
  },
  methods: {
    getErrorMessage() {
      if (this.error === "fusion_only_in_bobbie") {
        return this.$t("bobbie.onlyAvailableInIframeError");
      } else if (this.error === "no_token") {
        return this.$t("bobbie.missingToken");
      }
      return this.$t("bobbie.error");
    },

    async validateToken(accessToken) {
      const delayMs = 2000;
      const maxAttempts = 3;
      while (this.attempts < maxAttempts) {
        try {
          this.attempts++;
          const response = await API.authentication.validateBobbieToken({
            token: accessToken,
          });
          if (response && response.status === 200) {
            this.error = null;
            return response.data;
          }
          throw new Error("Validation failed");
        } catch (err) {
          console.error(err);
          await new Promise((resolve) => setTimeout(resolve, delayMs));
        }
      }

      return null;
    },
  },
};
</script>

<style scoped>
.progress-container {
  color: var(--color-grey50);
  text-align: center;
  font-size: 24px;
  font-weight: 700;
}
.wrapper {
  background: black;
  height: 100vh;
}
.progress-hint {
  font-size: 18px;
  font-weight: normal;
}
</style>
